// tslint:disable:no-any
import * as types from '../actions/actionTypes';

export default (state: any = [], action: any) => {
    switch (action.type) {
        case types.LOAD_DIVE_DATA_SUCCESS:
            return action.dive;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/diveDataReducer.ts